<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'ValuationModelPage',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/valuation-model/ValuationModelPage.vue